import { FC, useState } from 'react'
import { Button, Divider, Grid, Typography } from '@mui/material'
import CategoryIcon from '@mui/icons-material/Category';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import categoria_prueba from '../../../assets/image/categoria_prueba.png';
import { SearcherKFCProductModal } from './SearcherKFCProductModal';
import { RoutesMap } from '../../../types';
import { useLocation } from 'react-router-dom';

const products = [
    { id: 1, name: 'Llanta' },
    { id: 2, name: 'Llanta' },
    { id: 3, name: 'Llanta' },
    { id: 4, name: 'Llanta' },
]


const SearcherKFCPopover: FC<any> = () => {
    const [showModalProduct, setShowModalProduct] = useState<boolean>(false)
    const { pathname } = useLocation();

    return (
        <div style={{ position: 'fixed', zIndex: 9999, top: 70, left: '50%', maxWidth: '420px', height: '350px', backgroundColor: '#f4f4f4', borderRadius: '10px', padding: '10px', overflowY: 'auto', boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.3)', color: 'black' }}>
            <div>
                <div style={{ width: '95%', margin: 'auto', borderBottom: '1px solid #848485', cursor: 'pointer' }}>
                    <CategoryIcon sx={{ marginRight: '5px', fontSize: 'large' }} />
                    <p>MODA Y ACCESORIOS</p>
                </div>
                <div style={{ width: '95%', margin: 'auto', borderBottom: '1px solid #848485', cursor: 'pointer' }}>
                    <SubdirectoryArrowRightIcon sx={{ marginRight: '5px', fontSize: 'large' }} />
                    <p>LENTES DE SOL</p>
                </div>
            </div >
            <div style={{ backgroundColor: '#DEDFDE', width: '95%', margin: 'auto', borderBottom: '1px solid #848485' }}>
                <p>PRODUCTOS</p>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', margin: 'auto' }}>
                {products.map((product) =>
                    <div style={{
                        maxWidth: '180px', margin: '5px', display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <img style={{ width: '60%' }} src={categoria_prueba} alt="Categoria Prueba" />
                        <Divider sx={{ width: '80%', height: '1px', backgroundColor: 'rgba(0, 0, 0, 0.3)', marginTop: '5px' }} />
                        <div style={{ padding: '10px' }}>
                            <Grid item sx={{ width: '100%', marginLeft: 'auto' }}>
                                <Typography fontWeight={'500'} fontSize={'12px'} color={'red'} style={{ textDecoration: 'line-through', marginRight: '10px' }}> $127.350</Typography>
                                <Typography fontWeight={'500'} fontSize={'12px'}> $127.50</Typography>
                            </Grid>
                            <Grid item sx={{ width: '100%', marginLeft: 'auto', display: 'flex', flexDirection: 'column' }}>
                                <Typography fontWeight={'600'} fontSize={'14px'}>Llanta</Typography>
                                <Typography fontSize={'12px'}>NISSAN V16 1990-2012</Typography>
                            </Grid>
                            <Grid item sx={{ width: '100%' }}>
                                <Button sx={{ border: '2px solid #D0D0D0', borderRadius: '20px', fontSize: '7px', color: '#707070', height: '25px', margin: '5px' }}
                                    onClick={() => setShowModalProduct(true)}>Ver más</Button>
                                <Button sx={{ borderRadius: '20px', fontSize: '7px', backgroundColor: pathname === RoutesMap.SEARCHER_V3 ? '#91CBF9' : '#EBA058', color: '#fff', height: '25px' }}>Añadir al carrito</Button>
                            </Grid>
                        </div>
                    </div>
                )}
            </div>
            {
                showModalProduct &&
                <SearcherKFCProductModal
                    open={showModalProduct}
                    closeModal={() => setShowModalProduct(false)}
                />
            }
        </div >
    )
}

export default SearcherKFCPopover;